import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  href: "https://codezero.tw/",
  target: "_blank"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "© 2022 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeZeroLogo = _resolveComponent("CodeZeroLogo")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("a", _hoisted_1, [
      _createVNode(_component_CodeZeroLogo)
    ]),
    _hoisted_2,
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.$style.separator)
    }, null, 2),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.$style.termsBtn),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openTerms()))
    }, " 使用條款 ", 2)
  ]))
}